const CRISIS_LIST_MAP_TABS = {
  CRISIS_QUEUE: 0,
  STAFF_ALLOCATED: 1,
};

export default CRISIS_LIST_MAP_TABS;
